<template src="./index.html"></template>
<script>
	import data from './data.js';
export default {
	props: {
		dialogFormVisible_Name: {
			type: Boolean,
			default: false
		},
	},
	data() {
		return {
			tableData_picName:[],
			likeSearch:"",
			page: 1, //第几页
			limit: 10,
			search: {
			    customerNumber: '', //客户编号
			    customerName: '', //客户名称
			    isEffective: '1', //是否有效 0:停用 1:启用
			    taxIdentificationNumber: '', //纳税人识别号
			    customerTaxpayerType: '', ///客户纳税人类型
			    customerInvoiceType: '' //客户发票类型
			},
			radio_Name: 0,
			chooseallkh: {},
			total: '',
		};
	},
	created() {},
	mounted() {},
	watch: {
	    dialogFormVisible_Name: function(indexVal, oldVal) {
			if(indexVal){
				this.chooseallkh={}
				this.page=1
				this.limit=10
				this.radio_Name = 0;
				this.likeSearch = '';
				this.total=0
				this.getCustomerList()
			}
	}		
	},	
	methods: {
		/* 发票选择客户主数据 */
		radiochangekhClick(row, column, event) {
		  this.radio_Name = row.index;
		  this.chooseallkh = row;
		},
		/* 发票选择客户主数据 */
		radiochangekh(val) {
		    this.chooseallkh = val;
		},
		/* 客户主数据分页 */
		handleSizeChange(val) {
		    this.pagenum = val;
		    this.getCustomerList();
		},
		handleCurrentChange(val) {
		    this.page = val;
		    this.getCustomerList();
		},
		/* 客户主数据列表数据搜索 */
		forserchgroup() {
		    this.getCustomerList();
		},
		/* 关闭客户主数据弹框 */
		closedialogFormVisible_Name() {
		   this.$emit("closedialogFormVisible_Name","")
		},
		/* 客户主数据选择 */
		forsurekh() {
		this.$emit("forsurekh",this.chooseallkh)
		},
		forsurekhDblclick(row, column, event) {
		 this.$emit("forsurekh",row)
		},
		/*  获取客户主数据列表数据*/
		getCustomerList() {
		    let params = {
		        search: this.search,
		        likeSearch: this.likeSearch,
		        page: this.page,
		        limit: this.pagenum,
		        sort: 'asc',
		        order: 'customerNumber'
		    };
		    this.$https.fetchPost('/master/getInvoiceCustomerList', params).then(res => {
		        for (let i=0;i<res.data.data.length;i++){
		          res.data.data[i].index=(i+1);
		        }
		        this.tableData_picName = res.data.data;
		        this.total = res.data.count;
		    });
		},
	}
};
</script>

<style scoped lang="less">
@import url('./index.less');
</style>
